import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProviderAppointment, getProviderAppointmentDetails, addProviderAppointmentNotes } from "../slice/providerPanelAppointmentSlice";
import { getClientAppointmentNotes } from "../slice/providerPaymentSettingSlice";
// import ClientDetailsModal from '../components/provider_clientdetails_modal';
import ClientDetailsModal from "../../provider-client-details-model/components/index";
import { providerSendMessage } from "../../provider-chat/slice/providerChatSlice";
import { toast } from "react-toastify";
import jsPDF from "jspdf";
import axios from 'axios';

const ProviderPanelAppointment = () => {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);
    const { providerAppointments, providerAppointmentDetails } = useSelector((state) => state.providerAppointments);
    const { clientAppointmentNotes } = useSelector((state) => state.providerPaymentSetting);
    const [sortConfig, setSortConfig] = useState({ column: null, direction: "asc" });
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedAppointmentId, setSelectedAppointmentId] = useState(null);
    const [notes, setNotes] = useState('');
    const [present, setPresent] = useState('yes');
    const [selectedImages, setSelectedImages] = useState([]);
    const [document, setDocument] = useState(null);
    const [isSubmittingNotes, setIsSubmittingNotes] = useState(false);
    const [existingDocuments, setExistingDocuments] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);
    {/*  Model code */ }
    const [selectedClient, setSelectedClient] = useState(null);
    const [selectedAppointmentNotesPDF, setSelectedAppointmentNotesPDF] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const openClientModal = (id) => {
        setSelectedClient(id);
        setShowModal(true);
    };

    const closeClientModal = () => {
        setSelectedClient(null);
        setShowModal(false);
    };

    const providerToken = localStorage.getItem("provider_access_token");
    

    useEffect(() => {
        dispatch(getProviderAppointment(providerToken));
        dispatch(getClientAppointmentNotes(providerToken));
    }, [dispatch]);

    // console.log("clientAppointmentNotes", clientAppointmentNotes);
    // console.log("providerAppointmentDetails", providerAppointmentDetails);

    const handleNoteChange = (e) => {
  const { name, value } = e.target;

  if (name === 'notes') {
    setNotes(value);
  } else if (name === 'present') {
    setPresent(value);
  }
};


    const handleAddNotes = async () => {
        if (!notes && !document) {
            alert("Please enter notes or upload a document.");
            return;
        }

        const formData = new FormData();
        formData.append('present', present);
        formData.append('notes', notes);
        selectedImages.forEach((file) => {
            formData.append("documents", file);
        });
        // if (document) {
        //     formData.append('documents', document);
        // }

        try {
            setIsSubmittingNotes(true);
            await dispatch(
            addProviderAppointmentNotes({
                token: providerToken,
                appointment_id: selectedAppointmentId,
                data: formData,
            })
            ).unwrap();

            // alert("Notes added successfully");
            toast.success("Notes added successfully!");
            setNotes('');
            setDocument(null);
            setShowDetailsModal(false);
            dispatch(getProviderAppointment(providerToken));
            dispatch(getClientAppointmentNotes(providerToken));
        } catch (error) {
            toast.error("Failed to add notes!");
            console.error(error);
        } finally {
            setIsSubmittingNotes(false);
        }
    };


    // const handleShowDetails = async (appointmentId) => {
    //     try {
    //         setNotes('');
    //         setSelectedImages([]);
    //         setSelectedAppointmentId(appointmentId);
    //         await dispatch(getProviderAppointmentDetails({ id: appointmentId, token: providerToken }));
    //         setShowDetailsModal(true);
    //     } catch (err) {
    //         console.error("Failed to fetch appointment details:", err);
    //     }
    // };

// const handleShowDetails = async (appointmentId) => {
//     console.log("appointmentId", appointmentId);
//     dispatch(getClientAppointmentNotes(id));
//   setSelectedAppointmentId(appointmentId);
//   setSelectedImages([]);
//   setExistingDocuments([]);
//   setNotes('');

//   console.log("clientAppointmentNotes", clientAppointmentNotes);
//   const note = clientAppointmentNotes.find(n => n.appointment_id === appointmentId);
//   console.log("note", note);
//   if (note) {
//     setNotes(note.notes || '');
//     setPresent(note.present || 'yes');
//     const documentList = note.documents
//       ? note.documents.split(',').map(doc => doc.trim()).filter(Boolean)
//       : [];
//     setExistingDocuments(documentList);
//   }

//   await dispatch(getProviderAppointmentDetails({ id: appointmentId, token: providerToken }));
//   setShowDetailsModal(true);
// };

const handleShowDetails = async (appointmentId, paymentId) => {
  setSelectedAppointmentId(appointmentId);
  setSelectedImages([]);
  setExistingDocuments([]);
  setNotes('');

  const action = await dispatch(getClientAppointmentNotes({ appointmentId, paymentId }));

  if (action.payload && action.payload.length > 0) {
    
    // Find the note for this appointmentId
    const fetchedNote = action.payload.find(
      note => note.appointment_id === appointmentId
    );

    // console.log("fetchedNote", fetchedNote);
    setSelectedAppointmentNotesPDF(fetchedNote)
    if (fetchedNote) {
      setNotes(fetchedNote.notes || '');
      setPresent(fetchedNote.present || 'yes');

      const documentList = fetchedNote.documents
        ? fetchedNote.documents.split(',').map(doc => doc.trim()).filter(Boolean)
        : [];
      setExistingDocuments(documentList);
    }
  }

  await dispatch(getProviderAppointmentDetails({
    id: appointmentId,
    token: providerToken
  }));

  setShowDetailsModal(true);
};

    const sortedData = Array.isArray(providerAppointments)
    ? [...providerAppointments].sort((a, b) => {
        if (sortConfig.column === null) return 0;

        const key = sortConfig.column;

        const valA = a[key] ?? "";
        const valB = b[key] ?? "";

        if (!isNaN(valA) && !isNaN(valB)) {
            return sortConfig.direction === "asc"
            ? valA - valB
            : valB - valA;
        } else {
            return sortConfig.direction === "asc"
            ? valA.toString().localeCompare(valB.toString())
            : valB.toString().localeCompare(valA.toString());
        }
        })
    : [];
    
    const getAppointmentTypeLabel = (type) => {
        switch (type) {
            case 'C':
            return 'Consult';
            case 'H':
            return 'Hourly';
            case 'S':
            return 'Subscription';
        }
    };

   const handleSort = (columnKey) => {
      let direction = "asc";
      if (sortConfig.column === columnKey && sortConfig.direction === "asc") {
         direction = "desc";
      }
      setSortConfig({ column: columnKey, direction });
   };

const handleStartMeeting = async (appointmentId) => {
    // console.log("appointmentId", appointmentId);
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/provider/create-meeting`,
      { appointmentId } // ✅ Send in request body
    );

    if (response.data.success) {
      const { adminJoinUrl } = response.data;

      window.open(adminJoinUrl, '_blank');
      console.log('✅ Meeting Started:', adminJoinUrl);

      // Redirect to the meeting (or store URL for Join button)
    //   dispatch(getProviderAppointmentDetails(providerToken))
      return adminJoinUrl;
    } else {
       toast.error("Failed to create meeting!", {
            position: "top-right",
            autoClose: 2000,
            style: { fontSize: "0.85rem" },
        });
        setTimeout(() => {
  window.location.reload();
}, 2100);
      console.error('❌ Meeting creation failed:', response.data.error);
    }
  } catch (err) {
    toast.error("Failed to create meeting!", {
            position: "top-right",
            autoClose: 2000,
            style: { fontSize: "0.85rem" },
        });
        setTimeout(() => {
  window.location.reload();
}, 2100);
    console.error('❌ Error while starting meeting:', err.error);
  }
};

const logoBase64 = "/assets/images/logo.png"; 
// Webpack/Vite will convert to Base64 automatically

const handleSendNoteAsPDF = async () => {
    // console.log("selectedAppointmentNotesPDF", selectedAppointmentNotesPDF);
    // return;
    setIsProcessing(true);
  const pdf = new jsPDF();
  const documentBaseUrl = process.env.REACT_APP_ATTACHMENT_NOTES_IMAGE_BACKEND_URL;

  let y = 20;
  const pageWidth = pdf.internal.pageSize.getWidth();
  const leftMargin = 14;
  const rightMargin = pageWidth - 14;
  const cardPadding = 6;
  const bottomPadding = 10;

  // Add header and logo without getBase64ImageFromURL
  if (logoBase64) {
  const imgWidth = 20;
  const imgHeight = 15; // fixed height

  // Logo position
  const logoX = pageWidth - imgWidth - leftMargin;
  const logoY = y - 10;

  // Draw background (a bit larger than logo)
  const padding = 3; // space around the logo
  pdf.setFillColor(0, 43, 69); // light gray background
  pdf.rect(
    logoX - padding,          // X position
    logoY - padding,          // Y position
    imgWidth + padding * 2,   // width
    imgHeight + padding * 2,  // height
    "F"                       // fill
  );

  // Text
  pdf.setFontSize(14);
  pdf.setFont(undefined, "bold");
  pdf.text(
    `Client: ${selectedAppointmentNotesPDF.appointment.client.first_name}`,
    leftMargin,
    y
  );
  pdf.setFontSize(12);
  pdf.setFont(undefined, "normal");
  pdf.text(
    `Service: ${selectedAppointmentNotesPDF.appointment.serviceAppo.service_name}`,
    leftMargin,
    y + 8
  );

  // Logo image
  pdf.addImage(
    logoBase64,
    "PNG",
    logoX,
    logoY,
    imgWidth,
    imgHeight
  );
}


  y += 20;

  let tempY = y + 10;
  tempY += 10;

  const notesText = `Notes: ${selectedAppointmentNotesPDF.notes || "N/A"}`;
  const splitNotes = pdf.splitTextToSize(
    notesText,
    pageWidth - 2 * (leftMargin + cardPadding)
  );
  tempY += splitNotes.length * 6 + 6;

  if (selectedAppointmentNotesPDF.documents) {
    const docs = selectedAppointmentNotesPDF.documents
      .split(",")
      .map((doc) => doc.trim())
      .filter(Boolean);
    if (docs.length > 0) {
      tempY += 8 + docs.length * 8;
    }
  }

  const cardHeight = tempY - y + cardPadding + bottomPadding;

  pdf.setFillColor(230, 230, 230);
  pdf.rect(leftMargin, y - cardPadding, pageWidth - 2 * leftMargin, cardHeight, "F");

  pdf.setDrawColor(200, 200, 200);
  pdf.rect(leftMargin, y - cardPadding, pageWidth - 2 * leftMargin, cardHeight);

  y += 10;
  pdf.text(`Date: ${selectedAppointmentNotesPDF.date_of_appointment}`, leftMargin + cardPadding, y);

  const presentText = `Present: ${selectedAppointmentNotesPDF.present}`;
  const presentWidth = pdf.getTextWidth(presentText);
  pdf.text(presentText, rightMargin - cardPadding - presentWidth, y);

  y += 10;
  pdf.text(splitNotes, leftMargin + cardPadding, y);
  y += splitNotes.length * 4 + 4;

  if (selectedAppointmentNotesPDF.documents) {
    const docs = selectedAppointmentNotesPDF.documents
      .split(",")
      .map((doc) => doc.trim())
      .filter(Boolean);
    if (docs.length > 0) {
      pdf.text("Documents:", leftMargin + cardPadding, y);
      y += 8;

      docs.forEach((doc, idx) => {
        const url = `${documentBaseUrl}/${doc}`;
        pdf.setTextColor(0, 0, 255);
        pdf.textWithLink(`View Document ${idx + 1}`, leftMargin + cardPadding, y, { url });
        pdf.setTextColor(0, 0, 0);
        y += 8;
      });
    }
  }

//   pdf.save(`appointment-note-${selectedAppointmentNotesPDF.date_of_appointment}.pdf`);

    const pdfBlob = pdf.output("blob");
const pdfFile = new File([pdfBlob], `appointment-note-${selectedAppointmentNotesPDF.date_of_appointment}.pdf`, {
  type: "application/pdf",
});
const clientId = selectedAppointmentNotesPDF.appointment.client_id;
  dispatch(
  providerSendMessage({
    input: "",
    id: clientId,
    to_type: "Icommunetech\\Client\\Models\\Client",
    file: pdfFile,
    token: providerToken,
  })
)
  .unwrap()
  .then(() => {
    setIsProcessing(false);
    toast.success("PDF sent successfully!");
  })
  .catch(() => {
    setIsProcessing(false);
    toast.error("Failed to send PDF.");
  });
};

    // console.log("providerAppointments", providerAppointments);

    return (
        <>
            <div class="col-md-8 col-xl-9 mt-4 mt-md-0">
                <div class="ps-2 ps-lg-4">
                    <h4 class="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                        Client Appointments                         
                    </h4>
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered align-middle" id="servicesTable">
                            <thead>
                                <tr>
                                    <th class="font-weight-semibold" onClick={() => handleSort("client")}>Client <span class="d-grid table-grad"><i class="fa fa-sort-asc sort-icon"></i><i class="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th class="font-weight-semibold" onClick={() => handleSort("client")}>Service<span class="d-grid table-grad"><i class="fa fa-sort-asc sort-icon"></i><i class="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th class="font-weight-semibold" onClick={() => handleSort("client")}>Type<span class="d-grid table-grad"><i class="fa fa-sort-asc sort-icon"></i><i class="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th width="20%" class="font-weight-semibold" onClick={() => handleSort("appointment_date")}>Appointment Date <span class="d-grid table-grad"><i class="fa fa-sort-asc sort-icon"></i><i class="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th class="font-weight-semibold" onClick={() => handleSort("start_time")}>Start Time <span class="d-grid table-grad"><i class="fa fa-sort-asc sort-icon"></i><i class="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th class="font-weight-semibold" onClick={() => handleSort("end_time")}>End Time<span class="d-grid table-grad"><i class="fa fa-sort-asc sort-icon"></i><i class="fa fa-sort-down sort-icon" style={{ marginTop: "-8px" }}></i></span></th>
                                    <th class="font-weight-semibold">Action<span class="d-grid table-grad"></span></th>
                                    {/* <th className="font-weight-semibold">Meeting</th> */}
                                </tr>
                            </thead>
                            <tbody>
                                {sortedData.length > 0 ? (
                                    sortedData.map((appointment) => (
                                    <tr key={appointment.id}>
                                        {/* <td>{appointment.id}</td> */}
                                        <td> 
                                            <button className="btn btn-link p-0 text-decoration-underline"
                                                onClick={() => openClientModal(appointment.client.id)}>
                                                {appointment.client.first_name}
                                            </button> 
                                        </td>
                                        {/* <td>{appointment.id}</td> */}
                                        <td>{appointment.serviceAppo.service_name}</td>
                                        <td>{getAppointmentTypeLabel(appointment.type) }</td>
                                        <td>{appointment.start_date}</td>
                                        <td>
                                            {new Date(`1970-01-01T${appointment.start_time}`).toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </td>
                                        <td>
                                            {new Date(`1970-01-01T${appointment.end_time}`).toLocaleTimeString([], {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </td>
                                        {/* <td>
                                            <button className="btn btn-custom-primary me-2" onClick={() => handleShowDetails(appointment.id, appointment.payment_id)}>Add Note</button>
                                        </td> */}
                                        <td>
  {/* Add Note button always visible */}
  <button
    className="btn btn-custom-primary me-2"
    onClick={() => handleShowDetails(appointment.id, appointment.payment_id)}
  >
    Add Note
  </button>

  {/* Conditionally show Start/Join button */}
  {(() => {
    const now = new Date(); // Current local datetime
    const appointmentDate = new Date(appointment.start_date); // Only date (local)

    // If appointment is today
    const isToday = appointmentDate.toDateString() === now.toDateString();

    // Combine appointment date and time
    const [hours, minutes] = appointment.start_time.split(':');
    const appointmentDateTime = new Date(appointmentDate);
    appointmentDateTime.setHours(+hours, +minutes, 0, 0); // Local time

    // If date is in the past, do nothing extra
    if (appointmentDate < new Date(now.toDateString())) {
      return null;
    }

    // Show "Start Meeting" if it's time and no URL
    if (isToday && now >= appointmentDateTime && !appointment.session_url) {
      return (
        <button
          className="btn btn-custom-primary"
          onClick={() => handleStartMeeting(appointment.id)}
        >
          Start Meeting
        </button>
      );
    }

    // Show "Join" if it's time and URL exists
    if (isToday && now >= appointmentDateTime && appointment.session_url) {
      return (
        <a
          href={appointment.provider_session_url}
          className="btn btn-custom-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          Join
        </a>
      );
    }

    return null;
  })()}
</td>

                                      {/* <td>
  {(() => {
    const now = new Date(); // Current local datetime
    const appointmentDate = new Date(appointment.start_date); // Only date (local)

    // Prevent showing anything for past dates
    if (appointmentDate < new Date(now.toDateString())) {
      return null;
    }

    // Is it today?
    const isToday = appointmentDate.toDateString() === now.toDateString();

    // Combine appointment date + time to compare properly
    const [hours, minutes] = appointment.start_time.split(':');
    const appointmentDateTime = new Date(appointmentDate);
    appointmentDateTime.setHours(+hours, +minutes, 0, 0); // local time

    // ✅ Show "Start Meeting" if it's time and no URL
    if (isToday && now >= appointmentDateTime && !appointment.session_url) {
      return (
        <button
          className="btn btn-success"
          onClick={() => handleStartMeeting(appointment.id)}
        >
          Start Meeting
        </button>
      );
    }

    // ✅ Show "Join" if it's time and URL exists
    if (isToday && now >= appointmentDateTime && appointment.session_url) {
      return (
        <a
          href={appointment.session_url}
          className="btn btn-outline-primary"
          target="_blank"
          rel="noopener noreferrer"
        >
          Join
        </a>
      );
    }

    return null; // Nothing otherwise
  })()}
</td> */}

                                    </tr>
                                    ))
                                ) : (
                                    <tr>
                                    <td colSpan="4">No appointment found.</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                {showDetailsModal && providerAppointmentDetails && (
                    <div className="modal show d-block" tabIndex="-1">
                        <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title">Appointment Notes</h5>
                            <button type="button" className="btn-close" onClick={() => setShowDetailsModal(false)}></button>
                            </div>
                            <div className="modal-body">
                            <p><strong>Client:</strong> {providerAppointmentDetails.client?.first_name} {providerAppointmentDetails.client?.last_name}</p>
                            <p><strong>Date:</strong> {providerAppointmentDetails.start_date}</p>
                            <p>
                                <strong>Start Time:</strong>{" "}
                                {new Date(`1970-01-01T${providerAppointmentDetails.start_time}Z`).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                })}
                                </p>

                                <p>
                                <strong>End Time:</strong>{" "}
                                {new Date(`1970-01-01T${providerAppointmentDetails.end_time}Z`).toLocaleTimeString([], {
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    hour12: true,
                                })}
                            </p>
                            <div className="mb-3">
                                <label htmlFor="notes" className="form-label">Notes</label>
                                <textarea
                                id="notes"
                                name="notes"
                                className="form-control"
                                value={notes}
                                onChange={handleNoteChange}
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label d-block">Present</label>
                                <div className="form-check form-check-inline">
                                    <input
                                    className="form-check-input"
                                    type="radio"
                                    name="present"
                                    id="presentYes"
                                    value="yes"
                                    checked={present === 'yes'}
                                    onChange={handleNoteChange}
                                    />
                                    <label className="form-check-label" htmlFor="presentYes">
                                    Yes
                                    </label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input
                                    className="form-check-input"
                                    type="radio"
                                    name="present"
                                    id="presentNo"
                                    value="no"
                                    checked={present === 'no'}
                                    onChange={handleNoteChange}
                                    />
                                    <label className="form-check-label" htmlFor="presentNo">
                                    No
                                    </label>
                                </div>
                            </div>


                            <div className="col-sm-12">
                    <label className="form-label text-primary mb-1 font-weight-semibold required">Upload Image</label>
                    
                    <div className="d-flex flex-column flex-md-row w-100 gap-3 align-items-start">
                    {/* Upload Field */}
                    <div className="uploadfield flex-fill">
                        <div className="custom-file-upload position-relative">
                        <button
                            type="button"
                            className="upload-btn btn btn-custom-primary position-absolute"
                            onClick={() => fileInputRef.current?.click()}
                        >
                            Upload Files
                        </button>
                        <input
                            type="file"
                            name="document"
                            id="document"
                            ref={fileInputRef}
                            accept=".pdf,.doc,.docx,.jpg,.png"
                            multiple
                            style={{ display: "none" }} // Hide the default input
                            onChange={(e) => {
                            const filesArray = Array.from(e.target.files);
                            setSelectedImages((prev) => [...prev, ...filesArray]);
                            }}
                        />
                        </div>
                        <div className="file-name form-control" id="fileName" style={{ height: "auto" }}>
                        {selectedImages.length > 0
                            ? selectedImages.map((file, index) => <div key={index}>{file.name}</div>)
                            : "No file chosen"}
                        </div>
                    </div>
                    </div>
                  </div>
                  {existingDocuments.length > 0 && (
                    <div className="mt-3">
                        <strong>Existing Documents:</strong>
                        <ul className="mb-0 mt-2">
                        {existingDocuments.map((doc, idx) => (
                            <li key={idx} className="mt-2">
                            <a
                                href={`${process.env.REACT_APP_ATTACHMENT_NOTES_IMAGE_BACKEND_URL}/${doc}`}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                View Document {idx + 1}
                            </a>
                            </li>
                        ))}
                        </ul>
                    </div>
                    )}
                            </div>
                            <div className="modal-footer d-flex justify-content-between">
                            <button className="btn btn-secondary" onClick={() => setShowDetailsModal(false)}>
                                Close
                            </button>
                            {notes.trim().length > 0 && (
                            // <button
                            //     className="btn btn-custom-primary me-2"
                            //     onClick={handleSendNoteAsPDF}
                            // >
                            //     Send Notes to Client
                            // </button>
                            <button onClick={handleSendNoteAsPDF} disabled={isProcessing} className="btn btn-custom-primary me-2">
                              {isProcessing ? "Please wait..." : "Send Notes to Client"}
                            </button>
                            )}
                            <button
                                className="btn btn-primary"
                                onClick={handleAddNotes}
                                disabled={isSubmittingNotes}
                            >
                                {isSubmittingNotes ? "Saving..." : "Save Notes"}
                            </button>
                            </div>

                        </div>
                        </div>
                    </div>
                )}
                {/* Modal (conditionally rendered) */}
                {showModal && (
                    <ClientDetailsModal client={selectedClient} onClose={closeClientModal} />
                )}
            </div>
        </>
    );

};

export default ProviderPanelAppointment;
